/** Path constants cho toàn bộ SPA. Centralized để link/nav dùng
 *  cùng 1 nguồn — pattern của lumina-frontend/src/app/config/routes.ts. */

export const ROUTES = {
  login: "/login",
  upload: "/upload",
  apps: "/apps",
  appsDetail: (appId: string) => `/apps/${encodeURIComponent(appId)}`,
  confirm: "/confirm",
  plans: "/plans",
} as const;

export const NAV_ITEMS: {
  to: string;
  i18nKey: string;
  match: (pathname: string) => boolean;
}[] = [
  { to: ROUTES.upload, i18nKey: "nav.upload", match: (p) => p === "/upload" || p === "/" },
  { to: ROUTES.apps, i18nKey: "nav.apps", match: (p) => p === "/apps" || p.startsWith("/apps/") },
  { to: ROUTES.confirm, i18nKey: "nav.confirm", match: (p) => p.startsWith("/confirm") },
  { to: ROUTES.plans, i18nKey: "nav.plans", match: (p) => p.startsWith("/plans") },
];
